import { clsx } from "clsx";

import type { JSX } from "react";

interface BadgeWrapperProps {
  children: JSX.Element;
  badgeClassName: string;
  value?: number;
}

export default function BadgeWrapper({
  children,
  badgeClassName,
  value,
}: BadgeWrapperProps) {
  return (
    <div className="relative">
      {children}
      <div
        className={clsx(
          "absolute rounded-full outline-white bg-purple-500 items-center justify-center flex text-white outline-2 text-button-xxs",
          badgeClassName,
        )}
      >
        {value}
      </div>
    </div>
  );
}
